/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Readymade_BusinessInputs */

const en_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Ready-Made Business`)
};

const es_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu negocio listo para usar`)
};

const fr_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre entreprise clé en main`)
};

const de_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein fertiges Geschäft`)
};

const ja_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなただけのビジネスがすぐに完成`)
};

const zh_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的现成商业平台`)
};

const ar_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عملك التجاري الجاهز`)
};

const id_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisnis Siap Pakai Anda`)
};

const it_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Tuo Business Pronto all'Uso`)
};

const ru_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш готовый бизнес`)
};

const pt_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Seu Negócio Pronto para Usar`)
};

const ko_your_readymade_business = /** @type {(inputs: Your_Readymade_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나만의 준비된 비즈니스`)
};

/**
* | output |
* | --- |
* | "Your Ready-Made Business" |
*
* @param {Your_Readymade_BusinessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_readymade_business = /** @type {((inputs?: Your_Readymade_BusinessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Readymade_BusinessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_readymade_business(inputs)
	if (locale === "es") return es_your_readymade_business(inputs)
	if (locale === "fr") return fr_your_readymade_business(inputs)
	if (locale === "de") return de_your_readymade_business(inputs)
	if (locale === "ja") return ja_your_readymade_business(inputs)
	if (locale === "zh") return zh_your_readymade_business(inputs)
	if (locale === "ar") return ar_your_readymade_business(inputs)
	if (locale === "id") return id_your_readymade_business(inputs)
	if (locale === "it") return it_your_readymade_business(inputs)
	if (locale === "ru") return ru_your_readymade_business(inputs)
	if (locale === "pt") return pt_your_readymade_business(inputs)
	return ko_your_readymade_business(inputs)
});